import React, { useEffect } from 'react';
import { PositionsDetails } from './PositionsDetails';
import { Button, useAnalytics, BottomSheetModal, BottomSheetModalWebProps } from '@medely/ui-kit';
import { IPosition } from '@medely/types';
import { useCurrentUser } from '@mp/hooks';

export type PositionsDetailsModalProps = {
  open: BottomSheetModalWebProps['isOpen'];
  onClose: BottomSheetModalWebProps['onClose'];
  positions: IPosition[];
};

export const PositionsDetailsModal = ({ open, onClose, positions }: PositionsDetailsModalProps) => {
  const { currentUser, proType } = useCurrentUser();
  const analytics = useAnalytics();

  useEffect(() => {
    if (!!currentUser && open) {
      analytics.track('Product Application Position Details - Viewed', {
        account_id: currentUser?.id,
        context: 'Product Application Position Details',
        subcontext: null,
        action: 'Viewed',
        pro_type: proType,
      });
    }
  }, [currentUser, open]);

  return (
    <BottomSheetModal
      isOpen={open}
      onClose={onClose}
      title="Position details"
      showDragIndicator={false}
      actions={
        <Button fullWidth onClick={onClose} testId="positions-details-modal-close-button">
          Close
        </Button>
      }
    >
      <PositionsDetails positions={positions} />
    </BottomSheetModal>
  );
};
